import React from "react";
import { Box, Typography, Button, Paper, useTheme } from "@mui/material";

const NotFound = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
       background: "linear-gradient(135deg, #0d0f19, #111627, #0b0e18)",
        // bgcolor: isDark ? "#121212" : "#f4f6f8",
        px: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          textAlign: "center",
          p: { xs: 4, md: 6 },
          borderRadius: "16px",
          maxWidth: "500px",
          bgcolor: isDark ? "#1a237e" : "#fff",
          color: isDark ? "#fff" : "#1a237e",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Background accent circle */}
        <Box
          sx={{
            position: "absolute",
            width: "300px",
            height: "300px",
            bgcolor: isDark ? "#d50000" : "#1a237e",
            borderRadius: "50%",
            top: "-100px",
            right: "-100px",
            opacity: 0.2,
          }}
        />

        {/* 404 Text */}
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "4rem", md: "6rem" },
            fontWeight: "bold",
            mb: 2,
          }}
        >
          404
        </Typography>

        {/* Message */}
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
          Page Not Found
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 4, color: isDark ? "#ccc" : "text.secondary" }}
        >
          Oops! The page you are looking for doesn’t exist or has been moved.
        </Typography>

        {/* Home Button */}
        <Button
          variant="contained"
          href="/"
          sx={{
            bgcolor: "#d50000",
            px: 4,
            py: 1.5,
            borderRadius: "8px",
            fontWeight: 600,
            color: "#fff",
            "&:hover": {
              bgcolor: "#b71c1c",
              color: "#fff",
            },
          }}
        >
          Go Home
        </Button>
      </Paper>
    </Box>
  );
};

export default NotFound;
